import { validateWordFn } from './validateWordFn'
let codeLength = 60
export function editFromInfoValidate () {
  return {
    'ebOrder.mblNo': [
      { validator: validateWordFn.bind(20), trigger: 'blur' }
    ],
    'ebOrder.carrierName': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlan.shipAgencyName': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebOrder.vesselNameEn': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebOrder.podName': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebOrder.etd': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebOrder.mblTransportTermFrom': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebOrder.mblPaymentType': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartySh.countryName': [
      { required: true, message: '请输入', trigger: 'blur' },
      {validator: validateWordFn.bind(5*codeLength), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.partyMainCode': [
      { required: true, message: '请输入', trigger: 'blur' },
      {validator: validateWordFn.bind(100), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.partyMainName': [
      { required: true, message: '请输入', trigger: 'blur' },
      {validator: validateWordFn.bind(70), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.partyAddress': [
      { required: true, message: '请输入', trigger: 'blur' },
      {validator: validateWordFn.bind(70), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.partyMainNameCn': [
      {validator: validateWordFn.bind(300), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.tel': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.fax': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.email': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.postCode': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.aeoNo': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.contactPerson': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartySh.contactTel': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartyCn.countryName': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyCn.partyMainCode': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyCn.partySysCode': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyCn.aeoCodeType': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyCN.tel': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartyCN.fax': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartyCN.email': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartyCn.partyMainName': [
      { required: true, message: '请输入', trigger: 'blur' },
      { validator: validateWordFn.bind(70), trigger: 'blur' }
    ],
    'ebFtPlanPartyCn.partyAddress': [
      { required: true, message: '请输入', trigger: 'blur' },
      { validator: validateWordFn.bind(70), trigger: 'blur' }
    ],
    'ebFtPlanPartyNt.countryName': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyNt.partyMainCode': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyNt.partySysCode': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyNt.aeoCodeType': [
      { required: true, message: '请输入', trigger: 'blur' },
    ],
    'ebFtPlanPartyNT.tel': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartyNT.fax': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartyNT.email': [
      {validator: validateWordFn.bind(50), trigger: 'blur'}
    ],
    'ebFtPlanPartyNt.partyMainName': [
      { required: true, message: '请输入', trigger: 'blur' },
      { validator: validateWordFn.bind(70), trigger: 'blur' }
    ],
    'ebFtPlanPartyNt.partyAddress': [
      { required: true, message: '请输入', trigger: 'blur' },
      { validator: validateWordFn.bind(70), trigger: 'blur' }
    ],
  }
}

export function VGMEbCtnValidate () {
  const VGMTableRules = [
    {
      property: 'ctnNo',
      ruleName: "notNull",
      message: "箱号不能为空"
    },
    {
      min: 0,
      max: 50,
      property: 'ctnNo',
      ruleName: "richLength",
      message: "长度不能超过50"
    },
    {
      property: 'ctnSizeType',
      ruleName: "notNull",
      message: "箱型尺寸不能为空"
    },
    {
      property: 'vgmWeight',
      ruleName: "notNull",
      message: "VGM箱总重(KGS)"
    },
    {
      property: 'vgmShipperName',
      ruleName: "notNull",
      message: "责任人不能为空"
    },
    {
      property: 'vgmVerifyPerson',
      ruleName: "notNull",
      message: "责任人签名不能为空"
    },
    {
      property: 'vgmContactTel',
      ruleName: "notNull",
      message: "电话不能为空"
    },
    {
      property: 'vgmContactEmail',
      ruleName: "notNull",
      message: "联系人邮箱不能为空"
    }
  ];
  return VGMTableRules;
}

export function boxGoodsValidate () {
  const boxGoodsTableRules = [
    {
      property: 'brokerMblNo',
      ruleName: "notNull",
      message: "提单号不能为空"
    },
    {
      property: 'ctnNo',
      ruleName: "notNull",
      message: "箱号不能为空"
    },
    {
      property: 'sealNo',
      ruleName: "notNull",
      message: "封号不能为空"
    },
    {
      property: 'ctnSizeType',
      ruleName: "notNull",
      message: "箱型不能为空"
    },
    {
      property: 'noOfPackage',
      ruleName: "notNull",
      message: "件数不能为空"
    },
    {
      property: 'packageTypeName',
      ruleName: "notNull",
      message: "包装单位不能为空"
    },
    {
      property: 'grossWeight',
      ruleName: "notNull",
      message: "毛重(KGS)不能为空"
    },
    {
      property: 'cube',
      ruleName: "notNull",
      message: "体积(CBM)不能为空"
    },
    {
      min: 0,
      max: 10,
      property: 'hsCode',
      ruleName: "richLength",
      message: "HS CODE最大长度为10"
    },
  ];
  return boxGoodsTableRules;
}
